export enum ConversationType {
    PROJECT = 'p',
    PROJECT_TECHNICAL = 'pt',
    REQUEST = 'q',
    TASK = 't',
    WORK = 'w'
}
